import Vue from 'vue'
import axios from 'axios'
import device from 'current-device'
import App from './App.vue'
import router from './router'
import store from '@/store'
import FastClick from 'fastclick'
import Vant from 'vant'
import echarts from 'echarts'
import 'vant/lib/index.less'
import 'normalize.css/normalize.css'
import 'postcss-pxtorem'
import '@/assets/styles/iconfont/iconfont.css'
import '@/assets/styles/public.css'
import '@/assets/styles/reset.css'
import '@/assets/styles/ipad.less'
import '@/assets/styles/main.less'

import './common/valid'
import xyEnter from '@/components/index.js'
import xyUtils from '@/common/utils'
import xyapi from '@/common/api'
import '@vant/touch-emulator'

let startApp = function() {
  axios.get('/config.json').then(res => {
    // 移动端点击延迟
    if ('addEventListener' in document) {
      document.addEventListener(
        'DOMContentLoaded',
        function() {
          FastClick.attach(document.body)
        },
        false
      )
    }
    let ua = navigator.userAgent.toLowerCase()
    window.isIpad = device.ipad() || /(?:bzt)/.test(ua) || /(?:windows)/.test(ua) //华为 bzt-09  型号
    console.log(ua)
    window.onload = function() {
      document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('gesturestart', function(event) {
        event.preventDefault()
      })
    }
    Vue.config.productionTip = false
    Vue.prototype.xy = xyUtils
    Vue.prototype.xyapi = xyapi
    Vue.prototype.echarts = echarts

    Vue.use(Vant)
    Vue.use(xyEnter)

    let result = ''
    let platform = ''// 建营一体过来的单点
    res.data.url.forEach(value => {
      if (value.webUrL === location.origin) {
        result = value.apiUrl
        platform = value.platform// 建营一体过来的单点
        Vue.prototype.xyWebUrl = value.webUrL
        Vue.prototype.corpId = value.corpId !== undefined ? value.corpId : '' // dingding
      }
    })
    if (result) {
      Vue.prototype.xyMApi = result // 默认api
      Vue.prototype.platform = platform // 建营一体过来的单点
      Vue.prototype.xyUploadUrl = res.data.uploadData.uploadUrl // 资源上传地址
      Vue.prototype.xyUploadToken = res.data.uploadData.token // 资源上传用token
      Vue.prototype.xyViewUrl = res.data.uploadData.viewUrl // 展示资源用
    } else {
      alert('域名配置错误')
    }
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  })
}
startApp()
